import { Card, AspectRatio, Image, CardSectionProps } from "@mantine/core"
import { useChatPostAttachmentApi } from "../../../../../../attachment-api/chatPostAttachmentApi"
import { ChatPostAttachmentDto } from "../../../../../../@client/Theasoft_ApiServer_Chat"

export function PostAttachments({
  attachments,
  chatPostId,
  cardSectionProps,
}: {
  attachments: ChatPostAttachmentDto[]
  chatPostId: number
  cardSectionProps?: CardSectionProps
}) {
  const chatPostAttachmentAPI = useChatPostAttachmentApi()

  return (
    <Card.Section mih={0} {...cardSectionProps}>
      <AspectRatio h={"100%"} w="100%" ratio={16 / 9}>
        <Image
          w="100%"
          h={"100%"}
          fit="contain"
          src={chatPostAttachmentAPI.getFileUrl(
            attachments[0].attachmentId,
            chatPostId
          )}
          alt="Feed post"
        />
      </AspectRatio>
    </Card.Section>
  )
}
